import { Select } from "antd";
import { useCustomerLocationFilter } from "./index.hook";
import styles from "./index.module.less";
import { General } from "../../../util/General";

type Props = {
  selectedCustomerId: number | null;
  selectedLocationId: number | null;
  handleChangeCustomer: (value: number | null) => void;
  handleChangeLocation: (value: number | null) => void;
};

const CustomerLocationFilter = (props: Props) => {
  const config = useCustomerLocationFilter(props);

  return (
    <div className={styles["main-container"]}>
      <div className={styles["dropdown-container"]}>
        <span className={styles["dropdown_label"]}>Customer</span>
        <Select showSearch allowClear value={props.selectedCustomerId} listHeight={200} onChange={props.handleChangeCustomer} getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} className={styles["dropdown__selector"]} placeholder="Select Customer">
          {config.customerMasterList?.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item?.customer_name}
            </Select.Option>
          ))}
        </Select>
      </div>

      <div className={styles["dropdown-container"]}>
        <span className={styles["dropdown_label"]}>Location</span>
        <Select showSearch allowClear value={props.selectedLocationId} listHeight={200} onChange={props.handleChangeLocation} getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} className={styles["dropdown__selector"]} placeholder="Select Location">
          {config.locationList?.map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {item?.location_name}
            </Select.Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default CustomerLocationFilter;
